module.exports = __webpack_public_path__ + "media/images/gallery/constellations/bootes/boo_names-ca4cfa2c9979aa2a3e861b327b519939.gif";